<script>
	import * as Yup from "yup";
	import { useValidations } from "../../../../../SharedSvelte/Forms.svelte";
	import { 
		FormGroup, 
		Input, 
		Icon,
		Card,
		CardBody,
		CardHeader,
		CardText,
	} from "@sveltestrap/sveltestrap";
	import { /* calculateAge, isValidDate, getDateFormatter, */ baseUrl } from "../../../../../SharedSvelte/Common.svelte";
	//import { maskNumericValue } from "../../common/Forms.svelte";
	import { Loader } from "../../../../../SharedSvelte/GlobalLoader.svelte";
	import { appProfileState } from "../../state/ApplicationState.svelte";
	import { AddressTypes } from "./AddressInput.svelte";
	import AddressInput from "./AddressInput.svelte";
	import { PhoneTypes } from "./PhoneNumberInput.svelte";
	import PhoneNumberInput from "./PhoneNumberInput.svelte";
	import PersonalInfoHeader from "./PersonalInfoHeader.svelte";

	//const dateFormatter = getDateFormatter();

	const { validateField, validateForm, getErrors, resetErrors, removeError } = useValidations();
	
	let formData = $state({
		//firstName: appProfileState.workingDependent?.firstName,
		//lastName: appProfileState.workingDependent?.lastName,
		//ssn: appProfileState.workingDependent?.ssn,
		//dateOfBirth: "",
		//gender: appProfileState.workingDependent?.gender,
		//sexAtBirth: appProfileState.workingDependent?.sexAtBirth,
		//relationship: appProfileState.workingDependent?.relationship,
		memberId: appProfileState.workingDependent?.memberId,
		email: appProfileState.workingDependent?.email,
		preferredContactMethod: appProfileState.workingDependent?.contactMethod,
		documentDeliveryMethod: appProfileState.workingDependent?.documentDeliveryMethod,
	});
	
	// if (appProfileState.workingDependent?.dateOfBirth) {
	// 	var dob = new Date(appProfileState.workingDependent?.dateOfBirth);
	// 	formData.dateOfBirth = dateFormatter.format(dob);
	// }
	
	let homeOrCellError = $state("");
	let saveError = $state("");

	//let isSexAtBirthRequired = $derived(formData.gender === "U");
	let errors = $derived(getErrors());
	let formHasErrors = $state(false);
	let residentialInitialValues = 
			appProfileState.workingDependent?.residentialAddress1+
			appProfileState.workingDependent?.residentialAddress2+
			appProfileState.workingDependent?.residentialCity+
			appProfileState.workingDependent?.residentialState+
			appProfileState.workingDependent?.residentialZip;
	let mailingInitialValues = 
			appProfileState.workingDependent?.mailingAddress1+
			appProfileState.workingDependent?.mailingAddress2+
			appProfileState.workingDependent?.mailingCity+
			appProfileState.workingDependent?.mailingState+
			appProfileState.workingDependent?.mailingZip;
	let isSameAsResidential = $state(residentialInitialValues === mailingInitialValues);

	let residentialAddressInput;
	let mailingAddressInput;
	let homePhoneNumberInput;
	let cellPhoneNumberInput;

	const formSchema = Yup.object({
		// firstName: Yup.string()
		// 	.required("First Name is required")
		// 	.matches(/^[A-Za-z]{1}[A-Za-z -]{1,99}$/, "Invalid First Name"),
		// lastName: Yup.string()
		// 	.required("Last Name is required")
		// 	.matches(/^[A-Za-z]{1}[A-Za-z -]{1,99}$/, "Invalid Last Name"),
		// ssn: Yup.string()
		// 	.matches(/^(?!000)(?!666)(?!9[0-9][0-9])\d{3}[- ]?(?!00)\d{2}[- ]?(?!0000)\d{4}$/, "Invalid SSN")
		// 	.nullable(), // Allows the field to be null or undefined
		// 	// .transform((value, originalValue) =>
		// 	// 	originalValue === "" ? null : value,
		// 	// ), // Ensures empty strings are treated as null,
		// dateOfBirth: Yup.string()
		// 	.nullable()
		// 	.test(
		// 		"is-valid-dateofbirth",
		// 		"Invalid date or age",
		// 		function (value) {
		// 			if (!value) {
		// 				return true; // Not required, so null or empty string is valid
		// 			}
		// 			if (!isValidDate(value)) {
		// 				//console.log("invalid dob date", value);
		// 				return false;
		// 			}

		// 			const MAX_AGE = 110;
		// 			const today = new Date();
		// 			const age = calculateAge(new Date(value), today);
		// 			if (age < 0 || age > MAX_AGE) {
		// 				//console.log("age:", age);
		// 				return false;
		// 			}
		// 			return true;
		// 		},
		// 	),
		// relationship: Yup.string()
		// 	.required("Relationship is required"),
		// gender: Yup.string()
		// 	.required("Gender is required")
		// 	.oneOf(["M", "F", "U"], "Invalid Gender"), // Ensure gender is one of the valid options
		// sexAtBirth: Yup.string()
		// 	.when("gender", {
		// 		is: "U", // Check if the value of the 'gender' field is 'U'
		// 		then: (schema) => schema.required("Sex at birth required for this gender"),
		// 		otherwise: (schema) => schema.notRequired(),
		// 	}),
		email: Yup.string()
			.nullable()
			.email("Invalid Email address"),
		preferredContactMethod: Yup.string()
			.required("Preferred Contact Method is required"),
		documentDeliveryMethod: Yup.string()
			.required("Document Delivery Method is required"),
	});

	// function handleFirstNameChange(event) {
	// 	validateField(formSchema, "firstName", formData);
	// }

	// function handleLastNameChange(event) {
	// 	validateField(formSchema, "lastName", formData);
	// }

	// function handleSsnInput(event) {
	// 	const input = event.target;
	// 	formData.ssn = maskNumericValue(
	// 		input,
	// 		event.inputType,
	// 		"999-99-9999",
	// 		formData.ssn,
	// 	);
	// 	validateField(formSchema, "ssn", formData);
	// }

	// function handleDobInput(event) {
	// 	const input = event.target;
	// 	formData.dateOfBirth = maskNumericValue(
	// 		input,
	// 		event.inputType,
	// 		"99/99/9999",
	// 		formData.dateOfBirth,
	// 	);
	// 	validateField(formSchema, "dateOfBirth", formData);
	// }

	function handleEmailChange(event) {
		validateField(formSchema, "email", formData);
	}

	function handlePreferredContactMethodChange(event) {
		validateField(formSchema, "preferredContactMethod", formData);
	}

	function handleDocumentDeliveryMethodChange(event) {
		validateField(formSchema, "documentDeliveryMethod", formData);
	}

	// function handleRelationshipTypeChange(event) {
	// 	validateField(formSchema, "relationship", formData);
	// }

	// function handleGenderTypeChange(event) {
	// 	validateField(formSchema, "gender", formData);
	// 	if (!isSexAtBirthRequired) {
	// 		removeError("sexAtBirth");
	// 		formData.sexAtBirth = "";
	// 	}
	// }

	// function handleSexAtBirthTypeChange(event) {
	// 	validateField(formSchema, "sexAtBirth", formData);
	// }

	// function clearAllErrors() {
	// 	resetErrors();
	// 	saveError = "";
	// 	residentialAddressInput.clearAllErrors();
	//  mailingAddressInput.clearAllErrors();
	// }

	function cancelEditing() {
		appProfileState.showDependentEditor = false;
		appProfileState.workingDependent = null;
		window.scrollTo(0, 0);
	}

	async function saveDependent() {
		await validateForm(formSchema, formData);
		await residentialAddressInput.validate();
		await mailingAddressInput.validate();
		await homePhoneNumberInput.validate();
		await cellPhoneNumberInput.validate();
		//await validateHomeOrCellArePresent();
		if (formHasErrors) return;

		await residentialAddressInput.verify();
		if (!isSameAsResidential) await mailingAddressInput.verify();
		
		Loader.display();

		try {
			var preparedFormData = JSON.parse(JSON.stringify(formData));
			// if (preparedFormData.dateOfBirth) {
			// 	preparedFormData.dateOfBirth = new Date(preparedFormData.dateOfBirth);
			// }
			preparedFormData.residentialAddress = residentialAddressInput.getValues();
			preparedFormData.mailingAddress = mailingAddressInput.getValues();
			preparedFormData.homePhone = homePhoneNumberInput.getValues()?.phoneNumber
			preparedFormData.cellPhone = cellPhoneNumberInput.getValues()?.phoneNumber;

			const response = await fetch(`${baseUrl}Options/Profile/SaveDependent`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					__RequestVerificationToken: document.getElementsByName("__RequestVerificationToken")[0].value,
				},
				body: JSON.stringify(preparedFormData),
			});
			if (!response.ok) {
				const error = `Server exception: ${response.status} ${response.statusText}`;
				console.log(error);
				throw new Error();
			}

			const json = await response.json();
			if (!json.success) {
				console.log(json.errors);
				throw new Error(json.errors);
			}

			appProfileState.dependentDetails = json.dependentDetails;

			appProfileState.showDependentEditor = false;
			appProfileState.workingDependent = null;
			window.scrollTo(0, 0);
			
		} catch (err) {
			saveError = "Failed to save dependent information. ";
			if (err.message) saveError += err.message;
		} finally {
			Loader.hide();
		}
	}

	function handleSubmit(event) {
		event.preventDefault();
		saveDependent();
	}

	async function validateHomeOrCellArePresent()
	{
		const homeValue = (await homePhoneNumberInput.getValues())?.phoneNumber;
		const cellValue = (await cellPhoneNumberInput.getValues())?.phoneNumber;
		if (!homeValue && !cellValue) {
			homeOrCellError = "Home or Cell phone number is required";
		} else homeOrCellError = "";
	}

	$effect(() => {
		formHasErrors = 
			Object.keys(errors).length 
			|| residentialAddressInput.hasErrors() 
			|| mailingAddressInput.hasErrors() 
			|| homePhoneNumberInput.hasErrors()
			|| cellPhoneNumberInput.hasErrors() 
			|| homeOrCellError ? true : false;

		if (isSameAsResidential) {
			mailingAddressInput.setValues({ ...residentialAddressInput.getValues() });
		}
		mailingAddressInput.disableInputs(isSameAsResidential)

		if (homePhoneNumberInput.getValues()?.phoneNumber || cellPhoneNumberInput.getValues()?.phoneNumber){
			homeOrCellError = "";
		}
	});
	
</script>

<main>
	<h1 class="mt-3 mb-3 ms-3">
		Edit Dependent
	</h1>

	<PersonalInfoHeader
        fullName = {appProfileState.workingDependent?.fullName}
        memberId = {appProfileState.workingDependent?.memberId}
        ssn = {appProfileState.workingDependent?.ssn}
        dateOfBirth = {appProfileState.workingDependent?.dateOfBirth}
    />

	<form onsubmit={handleSubmit} novalidate>
		<!-- <div class="row">
			<div class="mb-3 col-md-3 col-sm-6 col-xs-12">
				<FormGroup floating spacing="mb-3" label="First Name">
					<Input
						placeholder="First Name"
						type="text"
						bind:value={formData.firstName}
						onchange={handleFirstNameChange}
						invalid={Boolean(errors.firstName)}
						feedback={errors.firstName}
					/>
				</FormGroup>
			</div>
			<div class="mb-3 col-md-3 col-sm-6 col-xs-12">
				<FormGroup floating spacing="mb-3" label="Last Name">
					<Input
						placeholder="Last Name"
						type="text"
						bind:value={formData.lastName}
						onchange={handleLastNameChange}
						invalid={Boolean(errors.lastName)}
						feedback={errors.lastName}
					/>
				</FormGroup>
			</div>
			<div class="mb-3 col-md-3 col-sm-6 col-xs-12">
				<FormGroup floating spacing="mb-3" label="SSN">
					<Input
						placeholder="###-##-####"
						type="text"
						bind:value={formData.ssn}
						oninput={handleSsnInput}
						invalid={Boolean(errors.ssn)}
						feedback={errors.ssn}
						inputmode="numeric"
						maxlength="11"
					/>
				</FormGroup>
			</div>
			<div class="mb-3 col-md-3 col-sm-4 col-xs-12">
				<FormGroup floating spacing="mb-3" label="Date of Birth">
					<Input
						placeholder="MM/DD/YYYY"
						type="text"
						bind:value={formData.dateOfBirth}
						oninput={handleDobInput}
						invalid={Boolean(errors.dateOfBirth)}
						feedback={errors.dateOfBirth}
						inputmode="numeric"
						maxlength="10"
					/>
				</FormGroup>
			</div>
		</div> -->
		

		<!-- <div class="row form-group">
			<div class="mb-3 col-md-3 col-sm-4 col-xs-12">
				<FormGroup floating spacing="mb-3" label="Relationship">
					<Input
						type="select"
						bind:value={formData.relationship}
						onchange={handleRelationshipTypeChange}
						invalid={Boolean(errors.relationship)}
						feedback={errors.relationship}
					>
						<option value=""></option>
						{#each appProfileState.relationshipTypes as relationshipType}
							<option value={relationshipType.code}>{relationshipType.text}</option>
						{/each}
					</Input>
				</FormGroup>
			</div>
			<div class="mb-3 col-md-3 col-sm-4 col-xs-12">
				<FormGroup floating spacing="mb-3" label="Gender">
					<Input
						type="select"
						bind:value={formData.gender}
						onchange={handleGenderTypeChange}
						invalid={Boolean(errors.gender)}
						feedback={errors.gender}
					>
						<option value=""></option>
						{#each appProfileState.genderTypes as genderType}
							<option value={genderType.code}>{genderType.text}</option>
						{/each}
					</Input>
				</FormGroup>
			</div>
			{#if isSexAtBirthRequired}
				<div class="mb-3 col-md-3 col-sm-3 col-xs-12">
					<FormGroup floating spacing="mb-3" label="Sex at Birth">
						<Input
							type="select"
							bind:value={formData.sexAtBirth}
							onchange={handleSexAtBirthTypeChange}
							invalid={Boolean(errors.sexAtBirth)}
							feedback={errors.sexAtBirth}
						>
							<option value=""></option>
							{#each appProfileState.sexAtBirthTypes as sexType}
								<option value={sexType.code}>{sexType.text}</option>
							{/each}
						</Input>
					</FormGroup>
				</div>
			{/if}
		</div> -->

		

		<div class="row">
			<div class="mb-3 col-sm-12 col-md-6">
				<br />
				<AddressInput
					bind:this={residentialAddressInput}
					addressType={AddressTypes.Residential}
					address1={appProfileState.workingDependent?.residentialAddress1}
					address2={appProfileState.workingDependent?.residentialAddress2}
					city={appProfileState.workingDependent?.residentialCity}
					usState={appProfileState.workingDependent?.residentialState}
					zip={appProfileState.workingDependent?.residentialZip}
				/>
			</div>
			<div class="mb-3 col-sm-12 col-md-6">
				<Input 
					type="checkbox" 
					label="Mailing is same as residential" 
					bind:checked={isSameAsResidential}
				/>
				<AddressInput
					bind:this={mailingAddressInput}
					addressType={AddressTypes.Mailing}
					address1={appProfileState.workingDependent?.mailingAddress1}
					address2={appProfileState.workingDependent?.mailingAddress2}
					city={appProfileState.workingDependent?.mailingCity}
					usState={appProfileState.workingDependent?.mailingState}
					zip={appProfileState.workingDependent?.mailingZip}
					disabled={isSameAsResidential}
				/>
			</div>
		</div>

		<div class="row">
			<div class="col">
				<Card class="mb-3">
					<CardHeader>Contact Information</CardHeader>
					<CardBody>   
						<CardText>     
							<div class="row">           
								<div class="col-md-4 col-sm-12 col-xs-12">
									<PhoneNumberInput
										bind:this={cellPhoneNumberInput}
										phoneType={PhoneTypes.Cell}
										phoneNumber={appProfileState.workingDependent?.cellPhone}
									/>
									{#if homeOrCellError}
										<p class="text-danger" role="alert">{homeOrCellError}</p>
									{/if}
								</div>
								<div class="col-md-4 col-sm-4 col-xs-12">
									<PhoneNumberInput
										bind:this={homePhoneNumberInput}
										phoneType={PhoneTypes.Home}
										phoneNumber={appProfileState.workingDependent?.homePhone}
									/>
								</div>
								<div class="col-md-4 col-sm-12 col-xs-12">
									<FormGroup floating spacing="mb-3" label="Email">
										<Input
											placeholder="Email"
											type="email"
											bind:value={formData.email}
											onchange={handleEmailChange}
											invalid={Boolean(errors.email)}
											feedback={errors.email}
										/>
									</FormGroup>
								</div>
						</div>
					 </CardText>  
					</CardBody>  
				</Card>
			</div>
		</div>

		<div class="row">
			<div class="col">
				<Card class="mb-3">
					<CardHeader>
						Communication Preferences
					</CardHeader>
					<CardBody>   				
						<CardText>
							<div class="row">
								<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
									<FormGroup floating spacing="mb-3" label="Preferred Contact Method">
										<Input
											type="select"
											bind:value={formData.preferredContactMethod}
											invalid={Boolean(errors.preferredContactMethod)}
											feedback={errors.preferredContactMethod}
											onchange={handlePreferredContactMethodChange}
										>									
											<option value=""></option>
											{#each appProfileState.contactMethods as contactMethod}
												<option value={contactMethod.code}>{contactMethod.text}</option>
											{/each}
										</Input>
									</FormGroup>
								</div>
								<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
									<FormGroup floating spacing="mb-3" label="Document Delivery">
										<Input
											type="select"
											bind:value={formData.documentDeliveryMethod}
											invalid={Boolean(errors.documentDeliveryMethod)}
											feedback={errors.documentDeliveryMethod}
											onchange={handleDocumentDeliveryMethodChange}
										>
											<option value=""></option>
											{#each appProfileState.documentDeliveryMethods as deliveryMethod}
												<option value={deliveryMethod.code}>{deliveryMethod.text}</option>
											{/each}
										</Input>
									</FormGroup>		
								</div>
							</div>													
						 </CardText>  
					</CardBody>  
				</Card>
			</div>
		</div>

		<div class="col">
			{#if saveError}
				<p class="text-danger" role="alert">{saveError}</p>
			{/if}
			<div class="button-group mb-3">
				<button
					type="button"
					class="btn btn-secondary btn-lg me-3"
					onclick={cancelEditing}>Cancel</button
				>
				<button
					type="submit"
					class="btn btn-primary btn-lg"
					disabled={formHasErrors}>Save</button
				>
			</div>
		</div>
	</form>
</main>